<template>
  <div
    class="w-full h-full flex relative bg-grey overflow-hidden"
    style="min-width: 400px; max-width: 400px"
  >
    <div class="h-full flex flex-col bg-grey max-w-full w-full" v-if="data.brand!='asr'">
      <!-- streetview -->
      <div
        class="w-full bg-grey flex relative justify-center items-center"
        style="aspect-ratio: 1"
        v-if="data.permission != 1"
      >
        No Street View for this coordinate
        <gmap-street-view-panorama
          v-if="data.permission"
          ref="pano"
          :position="{
            lat: data.lat,
            lng: data.lng,
          }"
          :pov="{
            heading: data.heading || 0,
            pitch: 0,
          }"
          :zoom="1"
          class="absolute left-0 top-0 w-full h-full"
        />
      </div>
      <div
        class="flex-1 flex w-full bg-white rounded-t-lg min-h-0"
        style="box-shadow: 2px -4px 15px rgba(0, 0, 0, 0.288)"
      >
        <div class="w-full h-full flex flex-no-wrap overflow-hidden flex-col">
          <div
            class="text-lg font-black truncate py-8 flex justify-between items-center px-4 border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light"
            style="letter-spacing: 0.5px; max-width: 100%"
          >
            <div class="flex flex-col flex-1">
              <span
                style="font-size: 20px; white-space: normal"
                class="break-words"
              >
                {{ data.assetName }}
              </span>
              <span class="font-semibold text-sm"> {{ data.lastUpdated }}</span>
              <span class="font-light text-xs flex items-center">
                <vs-icon icon="schedule" class="pr-1" />
                Updated</span
              >
            </div>
            <div class="flex flex-col gap-2">
              <vs-button
                @click="navigateToManageUnit"
                size="small"
                class="flex flex-center"
                >Manage</vs-button
              >
              <vs-button
                @click="$emit('get-unit')"
                color="success"
                size="small"
                class="flex flex-center"
                >Center View</vs-button
              >
            </div>
          </div>
          <!-- scroll -->
          <div
            class="w-full flex flex-1 flex-col flex-no-wrap overflow-auto min-h-0 px-5 py-6"
          >
            <div class="flex w-full" style="gap: 8px">
              <div
                v-for="(item, i) in widget"
                :key="i"
                class="relative border-solid border flex flex-1 flex-col justify-around items-center px-1 rounded-lg border-grey-light"
                style="aspect-ratio: 1"
              >
                <div
                  class="text-sm font-normal text-left absolute top-0 left-0 my-2 flex items-center"
                  style="height: fit-content"
                >
                  <div class="h-full px-2 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 12px"
                    />
                  </div>
                  {{ item.label }}
                </div>
                <div
                  class="text-lg font-bold leading-none tracking-tight"
                  :style="i == 0 ? { color: data.textColor } : void 0"
                >
                  {{ item.data }}
                </div>
              </div>
            </div>
            <div
              v-for="(item, i) in list"
              :key="i"
              class="text-lg font-black flex flex-col justify-between items-start"
              style="letter-spacing: 0.5px"
              :class="[item.label == 'Location' ? 'py-1' : 'py-4 ']"
            >
              <div
                class="w-full flex justify-between"
                :class="[
                  item.label == 'location'
                    ? 'flex-col items-start gap-4'
                    : 'items-center ',
                ]"
              >
                <div class="font-light text-sm flex items-center">
                  <div class="h-full px-2 pr-3 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 18px"
                    />
                  </div>
                  <div class="flex flex-col justify-center">
                    <div
                      class="capitalize"
                      :class="{
                        'font-bold text-base': item.label == 'heatmap',
                      }"
                    >
                      {{ item.label }}
                    </div>
                    <div v-if="item.caption" class="text-sm">
                      {{ item.caption }}
                    </div>
                  </div>
                </div>
                <span
                  class="text-sm"
                  :class="[
                    {
                      'text-primary cursor-pointer border-solid border-1 px-3 py-1 rounded-lg hover:bg-grey-light duration-2':
                        item.label == 'fuel' || item.label == 'temp',
                    },
                    {
                      'text-grey pointer-events-none':
                        (fetchFuelData && item.label == 'fuel') ||
                        (fetchFuelData && item.label == 'temp'),
                    },
                    { 'pl-3': item.label == 'location' },
                  ]"
                  @click="action(item.label)"
                >
                  {{
                    (fetchFuelData && item.label == 'fuel') ||
                    (fetchFuelData && item.label == 'temp')
                      ? `fetching data`
                      : item.data
                  }}
                </span>
                <!-- switch -->

                <vs-switch
                  v-model="showHeatmap"
                  size="small"
                  v-if="item.label == 'heatmap'"
                  color="success"
                >
                  <span slot="on">SHOW</span>
                  <span slot="off">HIDE</span>
                </vs-switch>
              </div>
              <div class="w-full mt-3 px-1" style="height: 1px">
                <div class="w-full h-full bg-grey-light"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-full flex flex-col bg-grey max-w-full w-full" v-if="data.brand=='asr'">
      <!-- streetview -->
      <div
        class="w-full bg-grey flex relative justify-center items-center"
        style="aspect-ratio: 1"
        v-if="data.permission != 1"
      >
        No Street View for this coordinate
        <gmap-street-view-panorama
          v-if="data.permission"
          ref="pano"
          :position="{
            lat: data.lat,
            lng: data.lng,
          }"
          :pov="{
            heading: data.heading || 0,
            pitch: 0,
          }"
          :zoom="1"
          class="absolute left-0 top-0 w-full h-full"
        />
      </div>
      <div
        class="flex-1 flex w-full bg-white rounded-t-lg min-h-0"
        style="box-shadow: 2px -4px 15px rgba(0, 0, 0, 0.288)"
      >
        <div class="w-full h-full flex flex-no-wrap overflow-hidden flex-col">
          <div
            class="text-lg font-black truncate py-8 flex justify-between items-center px-4 border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light"
            style="letter-spacing: 0.5px; max-width: 100%"
          >
            <div class="flex flex-col flex-1">
              <span
                style="font-size: 20px; white-space: normal"
                class="break-words"
              >
                {{ data.assetName }}
              </span>
              <span class="font-semibold text-sm"> {{ data.lastUpdated }}</span>
              <span class="font-light text-xs flex items-center">
                <vs-icon icon="schedule" class="pr-1" />
                Updated</span
              >
            </div>
            <div class="flex flex-col gap-2">
              <vs-button
                @click="navigateToManageUnit"
                size="small"
                class="flex flex-center"
                >Manage</vs-button
              >
              <vs-button
                @click="$emit('get-unit')"
                color="success"
                size="small"
                class="flex flex-center"
                >Center View</vs-button
              >
            </div>
          </div>
          <!-- scroll -->
          <div
            class="w-full flex flex-1 flex-col flex-no-wrap overflow-auto min-h-0 px-5 py-6"
          >
            <div class="flex w-full" style="gap: 8px">
              <div
                v-for="(item, i) in widget"
                :key="i"
                class="relative border-solid border flex flex-1 flex-col justify-around items-center px-1 rounded-lg border-grey-light"
                style="aspect-ratio: 1"
              >
                <div
                  class="text-sm font-normal text-left absolute top-0 left-0 my-2 flex items-center"
                  style="height: fit-content"
                >
                  <div class="h-full px-2 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 12px"
                    />
                  </div>
                  {{ item.label }}
                </div>
                <div
                  class="text-lg font-bold leading-none tracking-tight"
                  :style="i == 0 ? { color: data.textColor } : void 0"
                >
                  {{ item.data }}
                </div>
              </div>
            </div>
            <div
              v-for="(item, i) in list"
              :key="i"
              class="text-lg font-black flex flex-col justify-between items-start"
              style="letter-spacing: 0.5px"
              :class="[item.label == 'Location' ? 'py-1' : 'py-4 ']"
            >
              <div
                class="w-full flex justify-between"
                :class="[
                  item.label == 'location'
                    ? 'flex-col items-start gap-4'
                    : 'items-center ',
                ]"
              >
                <div class="font-light text-sm flex items-center">
                  <div class="h-full px-2 pr-3 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 18px"
                    />
                  </div>
                  <div class="flex flex-col justify-center">
                    <div
                      class="capitalize"
                      :class="{
                        'font-bold text-base': item.label == 'heatmap',
                      }"
                    >
                      {{ item.label }}
                    </div>
                    <div v-if="item.caption" class="text-sm">
                      {{ item.caption }}
                    </div>
                  </div>
                </div>
                <span
                  class="text-sm"
                  :class="[
                    {
                      'text-primary cursor-pointer border-solid border-1 px-3 py-1 rounded-lg hover:bg-grey-light duration-2':
                        item.label == 'fuel' || item.label == 'temp',
                    },
                    {
                      'text-grey pointer-events-none':
                        (fetchFuelData && item.label == 'fuel') ||
                        (fetchFuelData && item.label == 'temp'),
                    },
                    { 'pl-3': item.label == 'location' },
                  ]"
                  @click="action(item.label)"
                >
                  {{
                    (fetchFuelData && item.label == 'fuel') ||
                    (fetchFuelData && item.label == 'temp')
                      ? `fetching data`
                      : item.data
                  }}
                </span>
                <!-- switch -->

                <vs-switch
                  v-model="showHeatmap"
                  size="small"
                  v-if="item.label == 'heatmap'"
                  color="success"
                >
                  <span slot="on">SHOW</span>
                  <span slot="off">HIDE</span>
                </vs-switch>
              </div>
              <div class="w-full mt-3 px-1" style="height: 1px">
                <div class="w-full h-full bg-grey-light"></div>
              </div>
            </div>

            <vs-row v-if="data.watchHRMeta!='-'">
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="person"
                :title="data.watchHRMeta.watch_id_number"
                subtitle="Staff ID"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
               icon="explore"
                :title="data.watchHRMeta.watch_tags"
                subtitle="Tags"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
               icon="groups"
                :title="data.watchHRMeta.watch_position"
                subtitle="Position"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-row v-if="data.watchHRMeta!='-'">
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="explore"
                :title="data.watchHRMeta.watch_company"
                subtitle="Company"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
               icon="clock"
                :title="data.watchHRMeta.watch_hour"
                subtitle="Work Hour"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-row v-if="data.watchHRMeta!='-'">
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-list-item
              icon="explore"
                :title="data.watchHRMeta.watch_zone"
                subtitle="Zone"
              ></vs-list-item>
            </vs-col>

          </vs-row>
          </div>
        </div>
      </div>
    </div>
    <div
      class="absolute left-0 top-0 w-full h-full flex justify-center items-center bg-white"
      v-if="!data || detailsLoading"
    >
      {{
        detailsLoading
          ? 'fetching data...'
          : `Please select a unit to view details`
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showHeatmapProp: {},
    geoPOIData: {},
    detailsLoading: {},
    data: {
      default: {
        unitId: 863719060385094,
        mileage: 13691,
        speed: '49kph',
        ignition: 'ON (05:30:19)',
        idling: 0,
        gps: 'YES',
        lat: 1.504245,
        lng: 103.60804,
        fuel: '253L (65%)',
        immobilizer: 'OFF',
        volt: '28.5V',
        fuel2: 0,
        i1: 0,
        address:
          'Second Link Expressway, Lima Kedai, Iskandar Puteri, Johor Bahru, Iskandar Malaysia, Johor, 81380, Malaysia',
        temp: '-',
        temp2: 0,
        temp3: 0,
        temp4: 0,
        heading: 164,
        create_time: '2023-12-07T04:34:38.000Z',
        ts: 1701923678,
        meta: null,
        assetName: 'MW - AKN6112',
        brand: 'teltonika',
        type: 'LORRY/TRUCK',
        assetId: 2324,
        lastUpdated: '07/12/2023 | 12:34:38',
        idlingStatus: '-',
        tempFuel: '253L (65%)',
        lowFuel: false,
        rotation: 164,
        tempInput: '-',
        tempTemp: '-',
        tempVolt: '28.5V',
        fuelPct: 65,
        input: '-',
        status: 'Moving',
        textColor: '#28C76F',
        stop: false,
      },
    },
  },
  computed: {
    widget() {
      if (!this.data) return [];
      else if(this.userInfo.username=='mhbadmin' || this.userInfo.username=='ironwatch' || this.userInfo.username=='demowatch'){
        let arr = [
        { data: this.data.status, label: 'Status' },
        { data: this.data.gps, label: 'GPS' },
      //  { data: this.data.immobilizer, label: 'Immo' },
      ];
      return arr;
      }
      else {
        let arr = [
        { data: this.data.status, label: 'Status' },
        { data: this.data.gps, label: 'GPS' },
        { data: this.data.immobilizer, label: 'Immo' },
      ];
      return arr;
      }

    },
    list() {
      if(this.userInfo.username=='mhbadmin' || this.userInfo.username=='ironwatch'  || this.userInfo.username=='demowatch'){
        let list = [
        'ignition',
        ['idling', 'idlingStatus'],
        'speed',
        ['location', 'address'],
        'beacon'
      ];
      let arr = [];
      list.forEach((e) => {
        if (typeof e == 'string') {
          if (this.data[e] && this.data[e] != '-') {
            arr.push({ label: e, data: this.data[e] });
          }
        } else {
          if (this.data[e[1]] && this.data[e[1]] != '-') {
            arr.push({ label: e[0], data: this.data[e[1]] });
          }
        }
      });
      arr.push({ label: 'heatmap', caption: 'Travelled Today' });
      return arr;
      }
      else {
        let list = [
        'ignition',
        ['idling', 'idlingStatus'],
        ['odometer', 'mileage'],
        'speed',
        'input',
        ['voltage', 'volt'],
        'temp',
        'humidity',
        'fuel',
        ['location', 'address'],
      ];
      let arr = [];
      list.forEach((e) => {
        if (typeof e == 'string') {
          if (this.data[e] && this.data[e] != '-') {
            arr.push({ label: e, data: this.data[e] });
          }
        } else {
          if (this.data[e[1]] && this.data[e[1]] != '-') {
            arr.push({ label: e[0], data: this.data[e[1]] });
          }
        }
      });
      arr.push({ label: 'heatmap', caption: 'Travelled Today' });
      return arr;
      }

    },
  },
  watch: {
    showHeatmap() {
      this.$emit('show-heatmap', this.showHeatmap);
    },
    showHeatmapProp() {
      if (this.showHeatmapProp != this.showHeatmap) {
        this.showHeatmap = this.showHeatmapProp;
      }
    },
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showHeatmap: false,
      icon: {
        ignition: { i: 'vpn_key' },
        idling: { i: 'icon-alert-octagon', p: 'feather' },
        odometer: { i: 'icon-aperture', p: 'feather' },
        speed: { i: 'speed' },
        input: { i: 'gavel' },
        voltage: { i: 'bolt' },
        temp: { p: 'feather', i: 'icon-thermometer' },
        humidity: { p: 'feather', i: 'icon-droplet' },
        fuel: { i: 'local_gas_station' },
        status: { p: 'feather', i: 'icon-check-circle' },
        gps: { i: 'signal_cellular_4_bar' },
        immo: { i: 'lock' },
        location: { i: 'location_on' },
        beacon: { i: 'location_on' },
        heatmap: { i: 'route' },
      },
      fetchFuelData: false,
    };
  },
  methods: {
    async action(label) {
      if (label == 'fuel' || label == 'temp') {
        this.$emit('chart', [label, this.data]);
      }
    },
    navigateToManageUnit() {
      const assetId = this.data.assetId;
      const assetName = this.data.assetName;
      const routeData = this.$router.resolve({
        name: 'map-single',
        params: { assetId, assetName },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style scoped></style>
